import React from 'react'
import { useTranslation } from 'react-i18next'
import SectionComponent from '../../../../components/utils/SectionComponent'
import "./wrongInvoices.scss"

function WrongInvoices() {
  const { t } = useTranslation()

  return (
    <div className='container-wrong-invoices'>
      <div className="texts-wrong-invoices">
        <SectionComponent title={t("telecom.invoice.title")} text={t("telecom.invoice.section_text_1")} >
          <p>{t("telecom.invoice.section_text_2")}</p>
          <p>{t("telecom.invoice.section_text_3")}</p>
        </SectionComponent>
      </div>
    </div>
  )
}

export default WrongInvoices